import { Box, Chip, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import SMSSubscriptionHelpText from './SMSSubscriptionHelpText';

function ChipWithIcon({ status }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
      }}>
      <Box>{status?.title}</Box>
      <InfoIcon sx={{ fontSize: '18px' }} />
    </Box>
  );
}

function InsightChipWithToolTip({ status, sx = {} }) {
  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 480,
          },
        },
      }}
      placement="top"
      arrow
      title={<SMSSubscriptionHelpText status={status} />}>
      <Chip
        sx={{ cursor: 'pointer', ...sx }}
        color={status.color}
        variant="outlined"
        label={<ChipWithIcon status={status} />}
        size="small"
      />
    </Tooltip>
  );
}

export default InsightChipWithToolTip;
